'use client'

import React, { ComponentType } from 'react'
// import { TickerNav } from '@/components/game/TickerNav'
import { Game, GameEvent, GameLineup, GamePlayer } from 'types'
import { Scoreboard } from '@/components/game/Scoreboard'
import { TickerIcon } from '@/components/game/TickerIcon'
import { Heading } from '@/components/ui-other/text/Heading'
import {
  Calendar,
  Clock,
  Download,
  Info,
  MapPin,
  Share2,
  Shield,
  Users,
  Hash
} from 'react-feather'
import {
  formattedDate,
  formattedDateTimeFull,
  formattedTime
} from 'shared/timeHelper'
import Button from '@/components/ui-other/basic/Button'
import Link from '@/components/router/Link'
import {
  fieldPath,
  gamePath,
  livePath,
  roundPath,
  tournamentSchedulePath
} from 'shared/urlHelpers'
import { siteBaseUrl } from 'api/helpers'
import Overlay from '@/components/layout/Overlay'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'next-share'
import { isTournamentInLiveWhitelist } from 'shared/liveHelpers'
import TickarooTickerWidget from './TickarooTicker'
import LivePlayIcon from 'public/img/ci-icons/live-play.svg'
import { TickerNav } from './TickerNav'
import { Tooltip } from '@/components/ReactTooltip'

type TickerDetailProps = {
  game: Game
  lineup: GameLineup | null
  events: GameEvent[] | null
  // tickers: TickarooTickerListEntry[]
  preferLiveticker?: boolean
}

const TeamPlayers: ComponentType<{
  headline: string
  lineup: GamePlayer[]
  showNumbers: boolean | undefined
  showGoals: boolean | undefined
  showPenaltyGoals: boolean | undefined

  showPenalties: boolean | undefined
  showCardsRed: boolean | undefined
  showCardsYellow: boolean | undefined
  showCardsBlue: boolean | undefined
}> = ({
  headline,
  lineup,
  showNumbers,
  showGoals,
  showPenaltyGoals,

  showPenalties,
  showCardsRed,
  showCardsYellow,
  showCardsBlue
}) => {
  const showStatistic = (s: any) => (s && s > 0 ? s : '')
  const showCardAny = showCardsRed || showCardsYellow || showCardsBlue

  /*
          showGoals = true
          showPenaltyGoals = true
          showPenalties = true
          showCardsRed = true
          showCardsYellow = true
          showCardsBlue = true
      */

  return (
    <div>
      <Heading level={3}>{headline}</Heading>
      <table className="mb-4 w-full text-sm">
        <thead>
          <tr>
            {(showGoals ||
              showPenaltyGoals ||
              showPenalties ||
              showCardAny) && (
              <th
                colSpan={showNumbers ? 2 : 1}
                className="align-bottom p-1 border-r-2 border-white"
              ></th>
            )}
            {!(
              showGoals ||
              showPenaltyGoals ||
              showPenalties ||
              showCardAny
            ) && (
              <th
                colSpan={showNumbers ? 2 : 1}
                className="align-bottom p-1"
              ></th>
            )}

            {showGoals &&
              (showPenaltyGoals || showPenalties || showCardAny) && (
                <th className="align-bottom text-center p-1 border-r-2 border-white">
                  <TickerIcon type={'Goal'} noTicker />
                </th>
              )}
            {showGoals &&
              !(showPenaltyGoals || showPenalties || showCardAny) && (
                <th className="align-bottom text-center p-1 ">
                  <TickerIcon type={'Goal'} noTicker />
                </th>
              )}

            {showPenaltyGoals && (showPenalties || showCardAny) && (
              <th className="align-bottom text-center p-1 border-r-2 border-white">
                <TickerIcon type={'SevenMeterGoal'} noTicker />
              </th>
            )}
            {showPenaltyGoals && !(showPenalties || showCardAny) && (
              <th className="align-bottom text-center p-1">
                <TickerIcon type={'SevenMeterGoal'} noTicker />
              </th>
            )}

            {showPenalties && showCardAny && (
              <th className="align-bottom text-center p-1 border-r-2 border-white">
                <TickerIcon type={'TwoMinutePenalty'} noTicker />
              </th>
            )}
            {showPenalties && !showCardAny && (
              <th className="align-bottom text-center p-1">
                <TickerIcon type={'TwoMinutePenalty'} noTicker />
              </th>
            )}

            {showCardAny && (
              <th className="align-bottom text-center p-1">
                <TickerIcon type={'Card'} noTicker />
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {lineup.map((l, i) => {
            const showPenaltyGoalData =
              (l.penaltyGoals && l.penaltyGoals > 0) ||
              (l.penaltyMissed && l.penaltyMissed > 0) ||
              (l.penaltyGoals && l.penaltyMissed && l.penaltyMissed > 0)

            return (
              <tr key={l.id} className={i & 1 ? 'bg-gray-200' : ''}>
                {showNumbers && (
                  <td className="text-grey text-right font-bold px-1 text-xs">
                    {l.number}.
                  </td>
                )}

                {(showGoals ||
                  showPenaltyGoals ||
                  showPenalties ||
                  showCardAny) && (
                  <td className="border-r-2 border-white px-1 py-2">
                    {l.firstname || l.lastname
                      ? `${l.firstname} ${l.lastname}`
                      : 'k. A.'}
                  </td>
                )}
                {!(
                  showGoals ||
                  showPenaltyGoals ||
                  showPenalties ||
                  showCardAny
                ) && (
                  <td className="px-1 py-2">
                    {l.firstname || l.lastname
                      ? `${l.firstname} ${l.lastname}`
                      : 'k. A.'}
                  </td>
                )}

                {showGoals &&
                  (showPenaltyGoals || showPenalties || showCardAny) && (
                    <td className="border-r-2 border-white px-1 text-center">
                      {showStatistic(l.goals)}
                    </td>
                  )}
                {showGoals &&
                  !(showPenaltyGoals || showPenalties || showCardAny) && (
                    <td className="px-1 text-center">
                      {showStatistic(l.goals)}
                    </td>
                  )}

                {showPenaltyGoals && (showPenalties || showCardAny) && (
                  <td className="border-r-2 border-white px-1 text-center">
                    {`
                      ${showPenaltyGoalData ? l.penaltyGoals : ''}
                      ${showPenaltyGoalData ? '/' : ''}
                      ${
                        showPenaltyGoalData
                          ? (l.penaltyGoals ?? 0) + (l.penaltyMissed ?? 0)
                          : ''
                      }
                    `}
                  </td>
                )}
                {showPenaltyGoals && !(showPenalties || showCardAny) && (
                  <td className="px-1 text-center">
                    {showStatistic(l.penaltyGoals)}
                  </td>
                )}

                {showPenalties && showCardAny && (
                  <td className="border-r-2 border-white px-1 text-center">
                    {showStatistic(l.penalties)}
                  </td>
                )}
                {showPenalties && !showCardAny && (
                  <td className="px-1 text-center">
                    {showStatistic(l.penalties)}
                  </td>
                )}

                {showCardAny && (
                  <td className="px-1 text-center">
                    {l.yellowCards && l.yellowCards > 0 ? (
                      <TickerIcon type="Yellow" noTicker />
                    ) : (
                      ''
                    )}
                    {l.redCards && l.redCards > 0 ? (
                      <TickerIcon type="Red" noTicker />
                    ) : (
                      ''
                    )}
                    {l.blueCards && l.blueCards > 0 ? (
                      <TickerIcon type="Blue" noTicker />
                    ) : (
                      ''
                    )}
                  </td>
                )}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

const TeamList: ComponentType<{
  headline?: string
  lineup: any
}> = ({ headline, lineup }) => {
  return (
    <div>
      {headline && <p className="font-semibold mb-1">Offizielle</p>}
      <ul className="text-sm">
        {lineup.map((l: any) => (
          <li key={l.id}>
            {l.firstname} {l.lastname}{' '}
            {l.position && <span className="text-grey ml-3">{l.position}</span>}
          </li>
        ))}
      </ul>
    </div>
  )
}

const EventsInfo: ComponentType<{
  game: Game
  events: GameEvent[] | null
}> = ({ events }) => {
  if (!events) {
    return <></>
  }

  return (
    <ul className="tikjs-event-list tik3-event-list">
      {events.map((e) => (
        <li
          key={e.id}
          className="tik3-flex-event tikjs-event-item tik3-event-item"
        >
          <div className="tik3-flex-event__meta tik3-flex-meevent-meta tik3-event-item-meta">
            <div className="tik3-flex-event-meta__state tik3-flex-event-meta-state">
              <div className="tik3-flex-event-meta-state__time">
                <div className="tik3-event-item-meta-state">
                  <span className="tik3-even-item-meta-state-text">
                    {e.time}
                  </span>
                </div>
              </div>
              <TickerIcon type={e.type} />
            </div>
          </div>
          <div className="tik3-flex-event__content tik3-flex-event-content tik3-event-item-content">
            <p className="text-xl font-bold">{e.score}</p>
            {e.message && <p>{e.message}</p>}
          </div>
        </li>
      ))}
    </ul>
  )
}

const LineupInfo: ComponentType<{
  game: Game
  lineup: GameLineup | null
}> = ({ game, lineup }) => {
  if (!lineup) {
    return <></>
  }

  const showNumbers =
    lineup?.home.some((l) => l.number) || lineup?.away.some((l) => l.number)
  const showGoals =
    lineup?.home.some((l) => l.goals && l.goals > 0) ||
    lineup?.away.some((l) => l.goals && l.goals > 0)
  const showPenaltyGoals =
    lineup?.home.some((l) => l.penaltyGoals && l.penaltyGoals > 0) ||
    lineup?.away.some((l) => l.penaltyGoals && l.penaltyGoals > 0)

  const showPenalties =
    lineup?.home.some((l) => l.penalties && l.penalties > 0) ||
    lineup?.away.some((l) => l.penalties && l.penalties > 0)
  const showCardsRed =
    lineup?.home.some((l) => l.redCards && l.redCards > 0) ||
    lineup?.away.some((l) => l.redCards && l.redCards > 0)
  const showCardsYellow =
    lineup?.home.some((l) => l.yellowCards && l.yellowCards > 0) ||
    lineup?.away.some((l) => l.yellowCards && l.yellowCards > 0)
  const showCardsBlue =
    lineup?.home.some((l) => l.blueCards && l.blueCards > 0) ||
    lineup?.away.some((l) => l.blueCards && l.blueCards > 0)

  return (
    <>
      {(lineup.home.length > 0 ||
        lineup.away.length > 0 ||
        lineup.homeOfficials.length > 0 ||
        lineup.awayOfficials.length > 0) && (
        <>
          <h4 className="gameinfos pt-20 lg:pt-24 uppercase mb-2 ml-10">
            Aufstellung
          </h4>
          <div className="container-light py-4 px-5 md:px-4 rounded mb-10">
            <div className="xl:flex">
              <div
                className="view-vertical mb-8 w-full xl:w-1/2 justify-between xl:pr-4 xl:mr-4 xl:border-r-2 border-white
              "
              >
                {lineup.home.length > 0 && (
                  <div>
                    <TeamPlayers
                      headline={game.homeTeam.name}
                      lineup={lineup.home}
                      showNumbers={showNumbers}
                      showGoals={showGoals}
                      showPenaltyGoals={showPenaltyGoals}
                      showPenalties={showPenalties}
                      showCardsRed={showCardsRed}
                      showCardsYellow={showCardsYellow}
                      showCardsBlue={showCardsBlue}
                    />
                  </div>
                )}

                {lineup.homeOfficials.length > 0 && (
                  <TeamList
                    headline="Offizielle"
                    lineup={lineup.homeOfficials}
                  />
                )}
              </div>

              <div className="view-vertical mb-8 mt-8 md:mt-0 w-full xl:w-1/2 justify-between">
                {lineup.away.length > 0 && (
                  <TeamPlayers
                    headline={game.awayTeam.name}
                    lineup={lineup.away}
                    showNumbers={showNumbers}
                    showGoals={showGoals}
                    showPenaltyGoals={showPenaltyGoals}
                    showPenalties={showPenalties}
                    showCardsRed={showCardsRed}
                    showCardsYellow={showCardsYellow}
                    showCardsBlue={showCardsBlue}
                  />
                )}

                {lineup.awayOfficials.length > 0 && (
                  <TeamList
                    headline="Offizielle"
                    lineup={lineup.awayOfficials}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {lineup.referees.length > 0 && (
        <div className="view-vertical">
          <h4 className="gameinfos uppercase mb-2 ml-10">Schiedsrichter</h4>
          <div className="container-light py-5 px-10 rounded mb-10">
            <TeamList lineup={lineup.referees} />
          </div>
        </div>
      )}
    </>
  )
}

const GameInfo: ComponentType<{
  game: Game
}> = ({ game }) => {
  const shareUrl = `${siteBaseUrl}${gamePath(game)}`
  const shareIconSize = 48
  const shareTitle = game.tournament.name

  const hasLiveStream =
    game.livestreamUrl ?? isTournamentInLiveWhitelist(game.tournament)

  return (
    <>
      <h4 className="gameinfos uppercase mb-2 ml-10">Spielinformationen</h4>
      <div className="container-light py-5 px-10 rounded mb-10">
        <div className="md:flex md:justify-between items-center">
          <div className="gameinfos flex flex-col space-y-3">
            {game.startsAt && (
              <div className="flex">
                <div className="mr-5">
                  <Calendar />
                </div>
                <div>{formattedDate(game.startsAt)} </div>
              </div>
            )}
            {game.startsAt && game.showTime && (
              <div className="flex">
                <div className="mr-5">
                  <Clock />
                </div>
                <div>{formattedTime(game.startsAt)} Uhr</div>
              </div>
            )}
            {game.tournament.name && (
              <div className="flex">
                <div className="mr-5">
                  <Shield />
                </div>
                <div>
                  <Link href={tournamentSchedulePath(game.tournament)}>
                    {game.tournament.name}
                  </Link>
                  {game.tournament.name != game.round.name && (
                    <>
                      {' – '}
                      <Link href={roundPath(game.tournament, game.round)}>
                        {game.round.name}
                      </Link>
                    </>
                  )}
                </div>
              </div>
            )}
            {game.field?.name && game.field?.id !== '0' && (
              <div className="flex">
                <div className="mr-5">
                  <MapPin />
                </div>
                <div>
                  <Link href={fieldPath(game.field)}>
                    {game.field.name}
                    {game.field.city && <> ({game.field.city})</>}
                  </Link>
                </div>
              </div>
            )}
            {game.attendance && (
              <div className="flex">
                <Users className="mr-5" />
                <span>{game.attendance} Zuschauer</span>
              </div>
            )}
            {game.pdfUrl && (
              <div className="flex">
                <Download className="mr-5" />
                <Link href={game.pdfUrl} openInNewWindow>
                  Spielbericht herunterladen
                </Link>
              </div>
            )}
            {hasLiveStream && (
              <div className="flex">
                <LivePlayIcon width={24} height={24} className="mr-5" />
                <Link href={game.livestreamUrl ?? livePath()} openInNewWindow>
                  Livestream
                </Link>
              </div>
            )}
            {game.customUrl && (
              <div className="flex">
                <Info className="mr-5" />
                <Link href={game.customUrl} openInNewWindow>
                  {game.customUrlLabel ?? 'Info'}
                </Link>
              </div>
            )}
            {game.gameNumber && (
              <div className="flex">
                <Hash className="mr-5" />
                <span title={'Spielnummer ' + game.gameNumber}>
                  Spielnummer {game.gameNumber}
                </span>
              </div>
            )}
            {game.updatedAt && (
              <div className="flex">
                <Tooltip
                  className="selectable-tooltip"
                  anchorSelect="#game-info-updated-at"
                  openOnClick
                  clickable
                >
                  {game.meta}
                </Tooltip>

                <span
                  id="game-info-updated-at"
                  className="text-xs text-gray-500 prose"
                  style={{ paddingLeft: '46px' }}
                >
                  letztes Update: {formattedDateTimeFull(game.updatedAt)} Uhr
                </span>
              </div>
            )}
          </div>
          <div className="mt-5 ml-0 md:ml-4 md:mt-0">
            <Overlay
              small
              title="Teilen"
              trigger={
                <Button className="btn btn-primary" small>
                  <Share2 className="mr-3" /> Spiel teilen
                </Button>
              }
            >
              <div className="text-sm text-gray-600 mb-2">
                Dieses Spiel teilen auf
              </div>
              <div className="flex space-x-4 gab-4">
                <FacebookShareButton url={shareUrl} title={shareTitle}>
                  <FacebookIcon size={shareIconSize} />
                </FacebookShareButton>
                <TwitterShareButton url={shareUrl} title={shareTitle}>
                  <TwitterIcon size={shareIconSize} />
                </TwitterShareButton>
                <WhatsappShareButton
                  url={shareUrl}
                  title={shareTitle}
                  separator=":: "
                >
                  <WhatsappIcon size={shareIconSize} />
                </WhatsappShareButton>
                <TelegramShareButton url={shareUrl} title={shareTitle}>
                  <TelegramIcon size={shareIconSize} />
                </TelegramShareButton>
                <LinkedinShareButton url={shareUrl}>
                  <LinkedinIcon size={shareIconSize} />
                </LinkedinShareButton>
                <EmailShareButton
                  url={shareUrl}
                  subject={shareTitle}
                  body="body"
                >
                  <EmailIcon size={shareIconSize} />
                </EmailShareButton>
              </div>
            </Overlay>
          </div>
        </div>
      </div>
    </>
  )
}

const PartnerInfo: ComponentType<{
  game: Game
}> = ({ game }) => {
  return (
    <>
      {game.id.startsWith('sr.sport_event') && (
        <img
          style={{
            width: '200px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
          src="/img/data-by-sportradar.webp"
          alt="data by sportradar"
        />
      )}
    </>
  )
}

export const OfficialTickerDetail: ComponentType<TickerDetailProps> = ({
  game,
  lineup,
  events,
  preferLiveticker
}) => {
  const hasTickarooTicker =
    (game.tickerRef && game.tickerRef.startsWith('tickaroo:')) || false
  const hasEvents = (events && events.length > 0) || false
  const showTickarooTicker =
    hasTickarooTicker && (!hasEvents || preferLiveticker)

  if (showTickarooTicker) {
    const tickerParams = (game.tickerRef as string).split(':')

    return (
      <>
        <TickerNav
          game={game}
          hasEvents={hasEvents}
          hasTickarooTicker={hasTickarooTicker}
          hasPresstext={game.showPresstext}
        />
        <div className="block w-24 h-0.5 bg-primary mt-8 mx-auto"></div>
        <div className="tik3-ticker tik3-sportstype-handball tik3-ticker--style-tik3 tik3-ticker--locale-de">
          <TickarooTickerWidget
            liveBlogId={tickerParams[2]}
            clientId={tickerParams[1]}
            layout="timeline"
          />
          {!hasEvents && (
            <div id="aufstellung">
              <GameInfo game={game} />
            </div>
          )}
        </div>
      </>
    )
  }

  return (
    <>
      <TickerNav
        game={game}
        hasEvents={hasEvents}
        hasTickarooTicker={hasTickarooTicker}
        hasPresstext={game.showPresstext}
      />
      <div className="block w-24 h-0.5 bg-primary mt-8 mx-auto"></div>
      <div id="tickaroo-liveblog">
        <div className="tik3-ticker tik3-sportstype-handball tik3-ticker--style-tik3 tik3-ticker--locale-de">
          <Scoreboard game={game} />
          <EventsInfo game={game} events={events} />
          <div id="aufstellung">
            <LineupInfo game={game} lineup={lineup} />
            <GameInfo game={game} />
            <PartnerInfo game={game} />
          </div>
        </div>
      </div>
    </>
  )
}
